import { render, staticRenderFns } from "./ConclusionSection.vue?vue&type=template&id=6643615f&scoped=true&"
import script from "./ConclusionSection.vue?vue&type=script&lang=js&"
export * from "./ConclusionSection.vue?vue&type=script&lang=js&"
import style0 from "./ConclusionSection.vue?vue&type=style&index=0&id=6643615f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643615f",
  null
  
)

export default component.exports